import { readBrowserRouteMeta } from '@onxmaps/ai-toolkit/toolbox/definitions/appNavigation'
import router from '@/router'

/**
 * Active Vue Router route — emitted only when a matched route declares
 * `meta.ai.description`. Walks `matched` from leaf to root so a parent's
 * description is used when the active leaf doesn't declare one. Routes
 * without an authored ai description are intentionally hidden from the model.
 *
 * Metadata is read via the ai-toolkit's `readBrowserRouteMeta` (toolbox
 * `appNavigation`, RFC-0009) — the same convention `navigateRouteTool`'s
 * `collectBrowserRoutes` reads its route catalog from, so a route annotated
 * for this context is also ready to become navigable once fish-web wires up
 * that tool. No fish-web route currently declares `meta.ai`, so this always
 * returns `''` today.
 */
export const getActiveRouteContext = (): string => {
  const route = router.currentRoute.value
  const description = [...route.matched]
    .reverse()
    .map((r) => readBrowserRouteMeta(r.meta)?.description)
    .find((d): d is string => typeof d === 'string' && d.length > 0)
  if (!description) {
    return ''
  }
  const name = typeof route.name === 'string' ? route.name : ''
  const namePart = name ? `${name} ` : ''
  // `.path`, not `.fullPath` — the query string/hash can carry auth params
  // (e.g. `/auth/callback?token=...`) that shouldn't reach the model.
  return `active app navigation route: ${namePart}(${route.path}) — ${description}\n`
}
